import { FC } from 'react';
import { BsGeo } from 'react-icons/bs';

import { CompanyProfile } from 'models';
import { CompanyHelpers } from 'helpers/CompanyHelpers';
import { GEOHelpers } from 'helpers/GEOHelpers';

import { ProfileRow } from 'components/company-profile/components/ProfileRow';

type Location = CompanyProfile['locations'][0];

const LocationTeaser: FC<
    Location & {
        company: CompanyProfile;
    }
> = ({ company, ...location }) => {
    const { address, name } = location;

    if (!CompanyHelpers.hasLocationInformation(location)) {
        return null;
    }

    const addressLine = [
        [address?.street, address?.number].filter(Boolean).join(' '),
        [address?.postalCode, address?.city].filter(Boolean).join(' '),
        address?.state,
        address?.country,
    ]
        .filter(Boolean)
        .join(', ');

    const title = name || address?.city || address?.country;

    return (
        <ProfileRow
            leading={<BsGeo />}
            title={title}
            meta={addressLine !== title ? addressLine : undefined}
            metaLines="all"
            href={addressLine ? GEOHelpers.getGoogleMapsSearchURL([company.name, addressLine].join(', ')) : undefined}
            target="_blank"
        />
    );
};

export { LocationTeaser };
